import { v4 as uuid } from 'uuid';

const writeStyleToHead = (css) => {
  const head = document.head || document.getElementsByTagName('head')[0];
  const style = document.createElement('style');

  style.type = 'text/css';
  style.id = `vm2AutoGeneratedStyles-${uuid()}`;
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
  head.appendChild(style);
};

export default writeStyleToHead;
